import parse from 'html-react-parser'
import { StringOrJSX } from '../types/general'

const PARAGRAPH_TAG = /<\/?p[^>]*>/g
const SUPERSCRIPT_TAG = /<\/?sup[^>]*>/gi

export function htmlReactParserWrapper(
  input?: string,
  removeParagraphTag = false,
): StringOrJSX {
  if (removeParagraphTag) {
    input = input?.replace(PARAGRAPH_TAG, '')
  }
  if (input) {
    return parse(input)
  } else {
    return ''
  }
}

export function stripParagraphTagFromText(input?: string): string {
  if (input) {
    return input.replace(PARAGRAPH_TAG, '')
  } else {
    return ''
  }
}

export function replaceTradeMark(input: string = '') {
  const unicodeTradeMark = '\u2122'
  return input.replace('<sup>TM</sup>', unicodeTradeMark)
}

export function stripSupTagFromText(input?: string): string {
  return (input || '').replace(SUPERSCRIPT_TAG, '')
}
